const menus = {
  Home: '/home',
  BuyCar: '/buy-car',
  SellCar: '/sell-car',
  CustomPage: '/custom-page',
  YuanTongAuction: '',
  News: '/news',
  VehicleContrast: '/vehicle-contrast'
}
export default menus
